import { render, staticRenderFns } from "./SOVnesplus.vue?vue&type=template&id=76326cb4&scoped=true"
import script from "./SOVnesplus.vue?vue&type=script&lang=js"
export * from "./SOVnesplus.vue?vue&type=script&lang=js"
import style0 from "./SOVnesplus.vue?vue&type=style&index=0&id=76326cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76326cb4",
  null
  
)

export default component.exports